import { render, staticRenderFns } from "./AcessarTransferenciaListagem.vue?vue&type=template&id=6d6c68ae"
import script from "./AcessarTransferenciaListagem.vue?vue&type=script&lang=js"
export * from "./AcessarTransferenciaListagem.vue?vue&type=script&lang=js"
import style0 from "./AcessarTransferenciaListagem.vue?vue&type=style&index=0&id=6d6c68ae&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports